<template>
  <div>
    <p class="has-text-weight-bold">
      {{ $t("mp:page.application_details.application_data.title") }}
    </p>

    <p class="has-text-grey-icon">
      {{ $t("mp:page.application_details.application_data.subtitle") }}
    </p>

    <template v-if="loaded">
      <template v-if="fields && fields.length > 0">
        <div
          class="columns setting-tile mx-0 my-2"
          v-for="field in fields"
          :key="field.identifier"
        >
          <div class="column">
            {{ field.question }}
          </div>
          <div class="column has-text-weight-bold">
            {{ field.answer }}
          </div>
        </div>
      </template>

      <template v-else>
        <div class="columns setting-tile mx-0 my-2">
          <div class="column">
            {{ $t("mp:page.application_details.application_data.empty") }}
          </div>
        </div>
      </template>
    </template>

    <LoadingSkeleton v-else />
  </div>
</template>

<script>
import flowOverviewMixin from "../../mixins/flowOverviewMixin";
import LoadingSkeleton from "../../components/LoadingSkeleton";

export default {
  name: "ApplicationDetailsDynamicData",
  mixins: [flowOverviewMixin],
  props: {
    applicationId: {
      type: [Number, String],
      required: true,
    },
    application: {
      type: Object,
      required: true,
    },
  },
  components: {
    LoadingSkeleton,
  },
  async mounted() {
    await this.$store.dispatch(
      "application/setDynamicData",
      this.application.dynamicData
    );

    await this.$store.dispatch(
      "application/fetchFlowForApplication",
      this.applicationId
    );
    this.steps = this.$store.getters["application/flow"];

    this.fields = await this.createFields();

    this.loaded = true;
  },
  data() {
    return {
      loaded: false,
      steps: {},
      fields: [],
    };
  },
};
</script>
